(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bambino-reviews"] && !Shopify.designMode) return;
  try {
    
function initBambinoReviews(){
 const sections=[...document.querySelectorAll('[data-review-section]')];const root=sections.find(s=>s.dataset.continuation==='false');if(!root||root.dataset.ready)return;
 if(window.Shopify?.designMode)return;
 root.dataset.ready='true';const grid=root.querySelector('[data-review-grid]');
 sections.filter(s=>s!==root).forEach(s=>{s.querySelectorAll('[data-review-card]').forEach(c=>grid.append(c));s.hidden=true;});
 const cards=[...grid.querySelectorAll('[data-review-card]')];if(!cards.length)return;cards.forEach((c,i)=>c.dataset.order=i);
 const filter=root.querySelector('[data-review-filter]'),sort=root.querySelector('[data-review-sort]'),more=root.querySelector('[data-review-more]'),status=root.querySelector('[data-review-status]');let limit=12;
 const date=c=>{const [d,m,y]=c.dataset.date.split('/');return Date.UTC(+y,+m-1,+d);};
 function render(){let matches=cards.filter(c=>filter.value==='all'||(filter.value==='photo'?c.dataset.photo==='true':c.dataset.rating===filter.value));matches.sort((a,b)=>sort.value==='newest'?date(b)-date(a):sort.value==='highest'?b.dataset.rating-a.dataset.rating:sort.value==='lowest'?a.dataset.rating-b.dataset.rating:a.dataset.order-b.dataset.order);cards.forEach(c=>c.hidden=true);matches.forEach((c,i)=>{grid.append(c);c.hidden=i>=limit;});more.hidden=matches.length<=limit;status.textContent=matches.length?status.dataset.format.replace('__SHOWN__',Math.min(limit,matches.length)).replace('__TOTAL__',matches.length):status.dataset.empty;}
 root.querySelector('[data-review-controls]').hidden=false;root.querySelector('[data-review-pagination]').hidden=false;filter.addEventListener('change',()=>{limit=12;render();});sort.addEventListener('change',()=>{limit=12;render();});more.addEventListener('click',()=>{limit+=12;render();});
 render();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initBambinoReviews);else initBambinoReviews();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
